var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"小程序数据"}},[_c('ToutiaoAdvData',{ref:"ToutiaoAdvData"})],1),_c('TabPane',{attrs:{"label":"畅开花"}},[_c('ChangkaihuaData',{ref:"ChangkaihuaData"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }